import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Grid } from "@mui/material";
import moment from "moment";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import Label from "../../components/Common/Label";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import SearchBar from "../../components/Common/Searchbar";
import Table from "../../components/Common/Table";
import TablePageControl from "../../components/Common/TablePageControl";
import CustomButton from "../../components/Form/CustomButton";
import CustomIconButton from "../../components/Form/CustomIconButton";
import CustomSelect2 from "../../components/Form/CustomSelect2";
import DatePickerFilter from "../../components/Form/DatePickerFilter";
import Helpers from "../../helpers/helpers";
import { exportSupport, getSupport, resetSupportAttachmentState, resetSupportState, updateSupport } from "../../store/actions";
import MarkResolved from "./MarkResolvedModal";


const SupportManagement = ({ exportExcel, supportListing, editSupport, userPermission }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const [loading, setIsLoading] = useState(false);
    const [selectedRow, setSelectedRow] = useState();
    const [markResolvedOpen, setMarkResolvedOpen] = useState(false);
    const [checkedAll, setCheckedAll] = useState(false);
    const [filterObject, setFilterObject] = useState({ platform: '0', date: null, status: '0', inquiryType: '0' });
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("50");
    const [keyword, setSearch] = useState("");
    const [sort, setSorted] = useState("desc");
    const [sort_by, setSortBy] = useState("id");
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const [editable, setEditable] = useState(false);
    const [exportable, setExportable] = useState(false);
    const [viewable, setViewable] = useState(false);
    const searchRef = useRef(keyword);

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("view-support") && setViewable(true);
            userPermission?.includes("edit-support") && setEditable(true);
            userPermission?.includes("export-support") && setExportable(true);
            !userPermission?.includes("view-support") && navigate('/not-authorized');
        }
    }, [userPermission])

    useEffect(() => {
        searchRef.current = keyword;
    }, [keyword]);

    useEffect(() => {
        dispatch(resetSupportState())
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        initData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, length, sort, sort_by, filterObject]);

    const initData = () => {
        let payload = {
            page: page,
            length: length,
            sort: sort,
            sort_by: sort_by,
            name: searchRef.current,
            inquiryType: filterObject?.inquiryType,
            platform: filterObject?.platform,
            status: filterObject?.status,
            date: filterObject?.date,
        }
        Object.keys(payload).forEach(key => {
            if (!payload[key] || payload[key] === 'all' || payload[key] === '0') {
                delete payload[key];
            }
        });
        dispatch(getSupport(payload))
    }

    const resetFilter = () => {
        setPage("1");
        setFilterObject({ platform: '0', date: null, status: '0', inquiryType: '0' });
        setSearch('');
    }

    useEffect(() => {
        if (exportExcel?.code === "success") {
            setIsLoading(false)
            Helpers.handleDownloadExcelFile(exportExcel?.excel_base_64, 'Support');
            dispatch(resetSupportAttachmentState());
        }

    }, [exportExcel]);

    const statusList = [
        { value: "0", label: "All statuses" },
        { value: "pending", label: "Pending" },
        { value: "resolved", label: "Resolved" }
    ]

    const platformList = [
        { value: "0", label: "All platforms" },
        { value: "aspeed", label: "Aspeed" },
        { value: "ariba", label: "Ariba" },
    ]

    const inquiryTypes = [
        { value: "0", label: "All inquiry types" },
        { value: "general", label: "General Enquiries" },
        { value: "product_support", label: "Product Support" },
        { value: "account_issue", label: "Account Issues" },
        { value: "return_refund", label: "Return / Refund" },
        { value: "comment_suggestion", label: "Comment / Suggestion" },
    ];

    const header = [
        {
            Header: "Inquiry ID",
            columnID: "id",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <div>#{cellProps?.id || '-'}</div>
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Inquiry type",
            columnID: "inquiry_type",
            accessor: (cellProps) => {
                return (<React.Fragment>{Helpers?.convertToCustomTitleCase(cellProps?.inquiry_type)}</React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Full name",
            columnID: "first_name",
            accessor: (cellProps) => {
                return (<React.Fragment>{cellProps?.first_name} {cellProps?.last_name} </React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Phone number",
            columnID: "phone",
            accessor: (cellProps) => {
                return (<React.Fragment>{cellProps?.phone}</React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Sales platform",
            columnID: "platform",
            accessor: (cellProps) => {
                return (<React.Fragment>{Helpers?.capitalizeWords(cellProps?.platform)}</React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Created Date",
            columnID: "created_at",
            accessor: (cellProps) => {
                return (<React.Fragment>{moment(cellProps.created_at).format("DD MMM YYYY")}<br /><span style={{ color: "#A0A0A0" }}>{moment(cellProps.created_at).format("hh:mm A")}</span></React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Status",
            columnID: "status",
            accessor: (cellProps) => {
                return (<React.Fragment><Label.SupportStatusLabel label={cellProps?.status} marginLeft={"0px"} /></React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Action",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        {viewable && <Link to={`/view-inquiry/${cellProps.id}`}>
                            <CustomIconButton
                                iconName={'ri-eye-line'}
                                onClick={() => { '' }}
                            />
                        </Link>}
                        {
                            cellProps?.status === 'pending' && editable &&
                            <CustomIconButton
                                iconName={'ri-check-line'}
                                onClick={() => {
                                    setMarkResolvedOpen(true);
                                    setSelectedRow(cellProps);
                                }}
                            />
                        }
                    </React.Fragment>
                )
            },
            minWidth: 120,
            position: 'sticky',
            disableFilters: true,
            filterable: false,
        }
    ]

    const handleFilterChange = (key, value) => {
        setFilterObject((prevValues) => ({
            ...prevValues,
            [key]: value
        }));
    };

    const handleExport = () => {
        let filter = {
            status: filterObject?.status === "0" ? "" : filterObject?.status,
            inquiry_type: filterObject?.inquiryType === "0" ? "" : filterObject?.inquiryType,
            platform: filterObject?.platform === "0" ? "" : filterObject?.platform,
            create_at: filterObject?.date,
            search: keyword
        }
        Object.keys(filter).forEach(key => {
            if (!filter[key] || filter[key] === 'all') {
                delete filter[key];
            }
        });
        dispatch(exportSupport({
            sort: sort_by,
            sort_order: sort,
            filter: filter
        }));
        setIsLoading(true);
    }

    const handleSearch = (text) => {
        setSearch(text);
        setTimeout(() => {
            if (text === searchRef.current) {
                setPage("1");
                initData();
            }
        }, Helpers.searchInterval);
    }

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
                <Grid container item sm={12} xs={12} md={12} lg={10} className="d-flex align-items-center" spacing={1}>
                    <Grid item lg={2} md={3} xs={12}>
                        <SearchBar
                            value={keyword}
                            setValue={(e) => handleSearch(e)}
                        />
                    </Grid>
                    <Grid item lg={2.5} md={3} xs={12}>
                        <CustomSelect2
                            values={filterObject?.inquiryType || "-1"}
                            onChange={(e) => { setPage("1"); handleFilterChange('inquiryType', e) }}
                            data={inquiryTypes}
                            placeholder={"Inquiry Type"}
                        />
                    </Grid>
                    <Grid item lg={2.1} md={3} xs={12}>
                        <CustomSelect2
                            values={filterObject?.status || "-1"}
                            onChange={(e) => { setPage("1"); handleFilterChange('status', e) }}
                            data={statusList}
                            placeholder={"Status"}
                        />
                    </Grid>
                    <Grid item lg={2.2} md={3} xs={12}>
                        <CustomSelect2
                            values={filterObject?.platform || "-1"}
                            onChange={(e) => {setPage("1"); handleFilterChange('platform', e)}}
                            data={platformList}
                            placeholder={"Platform"}
                        />
                    </Grid>
                    <Grid item lg={2.5} md={3} xs={12}>
                        <DatePickerFilter
                            values={filterObject?.date && new Date(filterObject?.date)}
                            setFormValues={(e) => {
                                setPage("1");
                                setFilterObject((prevValues) => ({
                                    ...prevValues,
                                    date: e
                                }))
                            }}
                            keyword={'date'}
                        />
                    </Grid>
                    <Grid item lg={0.7} md={0.5} xs={12}>
                        <CustomButton
                            title={'Clear'}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#7BB9FA'}
                        />
                    </Grid>
                </Grid>
                {exportable && <Grid item lg={2} md={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'start' } }} alignItems={'center'}>
                    <CustomButton
                        title={<><i className="ri-download-2-line" style={{ marginRight: 5 }} />Export</>}
                        press={() => handleExport()}
                        height={32}
                        borderRadius={15}
                        borderStyle={"1px solid #babcbe"}
                    />
                </Grid>}
            </Grid>
        )
    }

    const renderHeader = () => {
        return (
            <div className="d-flex justify-content-between align-items-center p-1 pb-2">
                <div className="header d-flex">Support <div className="header-amount mx-2">{supportListing?.total || 0}</div></div>
            </div>
        )
    }

    const markAsResolvedModal = () => {
        return (
            <MarkResolved
                open={markResolvedOpen}
                close={() => setMarkResolvedOpen(false)}
                submit={() => handleSubmit()}
                selectedInquiry={selectedRow}
            />
        )
    }

    useEffect(() => {
        if (editSupport?.code === "success") {
            setNotification({
                open: true,
                msg: "Resolved",
                type: "success",
            })
            dispatch(resetSupportState())
            setMarkResolvedOpen(false)
            initData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editSupport]);

    const handleSubmit = () => {
        let data = {
            status: "resolved"
        }
        dispatch(updateSupport({ id: selectedRow?.id, support: data }))
    }


    return (
        <React.Fragment>
            <div className="page-content">
                <LoadingDialog open={loading || !supportListing?.data} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    {renderHeader()}
                    {customToolsBar()}
                    <Table
                        header={header}
                        data={supportListing?.data}
                        pageSize={length}
                        totalPage={supportListing?.last_page}
                        customToolsBar={true}
                        sort={sort}
                        setSorted={setSorted}
                        sort_by={sort_by}
                        setSortBy={setSortBy}
                        setCheckedAll={setCheckedAll}
                        checkedAll={checkedAll}
                    />
                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={supportListing?.last_page}
                    />
                    {markAsResolvedModal()}
                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Support, Login }) {
    return {
        supportListing: Support.support,
        delSupport: Support.delSupport,
        userData: Login?.verifyAdmin?.user?.data,
        delCustArry: Support?.delSupport,
        exportExcel: Support.exportSupport,
        editSupport: Support.editSupport,
        userPermission: Login.permissionArry,

    };
}


export default connect(mapStateToProps)(SupportManagement);